import { ITempAddress } from '../../../interfaces/temp.interface';
import { DialogCreators } from '../../../utils/dialog-creators';
import { DataLayerService } from '../../../services/data-layer-service';
import { LocalizationService } from '../../../services/localization-service';
import { ICheckAddress } from '@ts/services/online-ordering-service.interface';

export function buildNormalizedAddress(address: ITempAddress): string {
    return `${address.StreetNo} ${address.StreetName} ${address.City} ${address.State} ${address.Zip}`.replaceAll(/\s+/g, ' ').trim();
}

export async function isAddressBlockedAsync(
    service: { checkAddress(data: ICheckAddress): Promise<boolean>, postJSError(data: string): Promise<void> },
    address: ITempAddress | null,
    storeKey: string
): Promise<boolean> {
    if (!address)
        return false;

    try {
        return await service.checkAddress({
            SKY: storeKey,
            ADDR: buildNormalizedAddress(address),
            APT: address.Address2 ?? ""
        });
    } catch (error) {
        // Fail open: a check-address outage must not block every delivery order, so log it and let the order through.
        service.postJSError(`check-address failed: ${error}`).catch(() => undefined);
        return false;
    }
}

export function showBlockedAddressError(localizationService: LocalizationService, dataLayer: DataLayerService, address: ITempAddress): void {
    DialogCreators.messageBoxOk(
        localizationService,
        dataLayer,
        localizationService.names("OUT_DELIVERY").replace("{{address}}", buildNormalizedAddress(address)),
        true
    );
}
